module.exports = __webpack_public_path__ + "static/media/icon_menu_dots.7c9cf32c.svg";